import angular from 'angular';
import Navbar from './navbar/navbar';
import Hero from './hero/hero';
import User from './user/user';
import CompareTo from './compareTo/compareTo';

const commonModule = angular.module('app.common', [Navbar, Hero, User, CompareTo]).name;

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js